/**
 * Return the points whose `t` falls within `[startMs, endMs]` (inclusive).
 */
export function selectWindow<T extends { t: number }>(points: T[], startMs: number, endMs: number): T[] {
    if (endMs < startMs) return [];
    return points.filter((p) => p.t >= startMs && p.t <= endMs);
}
